import _classCallCheck from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/createClass.js";

var AudioAnalyser = /*#__PURE__*/function () {
  function AudioAnalyser(audio) {
    var fftSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2048;

    _classCallCheck(this, AudioAnalyser);

    this.analyser = audio.context.createAnalyser();
    this.analyser.fftSize = fftSize;
    this.data = new Uint8Array(this.analyser.frequencyBinCount);
    audio.getOutput().connect(this.analyser);
  }

  _createClass(AudioAnalyser, [{
    key: "getFrequencyData",
    value: function getFrequencyData() {
      this.analyser.getByteFrequencyData(this.data);
      return this.data;
    }
  }, {
    key: "getAverageFrequency",
    value: function getAverageFrequency() {
      var value = 0;
      var data = this.getFrequencyData();

      for (var i = 0; i < data.length; i++) {
        value += data[i];
      }

      return value / data.length;
    }
  }]);

  return AudioAnalyser;
}();

export { AudioAnalyser };